export default __webpack_public_path__ + "static/media/reembolsoProceso.0b7268c3.svg";